import {
  ApplicantSettings,
  ApplicationSettings,
  DEFAULT_PROMO_CODE_SETTINGS,
  FIELD_SETTINGS_DEFAULTS,
  RelationshipType,
} from '@common/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { AnyField } from 'types/fields';
import type { AnyPage, Section } from 'types/page';

type BuilderStoreReducer = {
  builderSteps: AnyPage[];
  activeStep: number;
  activeSection?: Section | null;
  // eslint-disable-next-line
  activeField: AnyField | {};
  currentTool: string;
  formId: string;
  isReadOnly: boolean;
  loadingSectionIndex?: number;
  applicationSettings: ApplicationSettings;
};

const DEFAULT_APPLICANT_SETTINGS: ApplicantSettings = {
  minAge: FIELD_SETTINGS_DEFAULTS.DATE_OF_BIRTH.MIN_AGE,
};

export const DEFAULT_APPLICATION_SETTINGS: ApplicationSettings = {
  [RelationshipType.Primary]: DEFAULT_APPLICANT_SETTINGS,
  [RelationshipType.Coapplicant]: DEFAULT_APPLICANT_SETTINGS,
  [RelationshipType.Guarantor]: DEFAULT_APPLICANT_SETTINGS,
  /** New forms default to promo entry off with label "Promo Code". */
  promoCode: { ...DEFAULT_PROMO_CODE_SETTINGS },
};

/**
 * Merge persisted version settings with builder defaults so promoCode defaults
 * are always present even when saved settings omit them.
 */
export function resolveApplicationSettings(
  settings?: ApplicationSettings | null,
): ApplicationSettings {
  return {
    ...DEFAULT_APPLICATION_SETTINGS,
    ...settings,
    promoCode: {
      ...DEFAULT_PROMO_CODE_SETTINGS,
      ...settings?.promoCode,
    },
  };
}

const initialState: BuilderStoreReducer = {
  builderSteps: [],
  activeStep: 0,
  activeSection: null,
  activeField: {},
  currentTool: '',
  formId: '',
  isReadOnly: true,
  loadingSectionIndex: undefined,
  applicationSettings: DEFAULT_APPLICATION_SETTINGS,
};

export const builderStoreSlice = createSlice({
  name: 'builderStoreSlice',
  initialState,
  reducers: {
    updateBuilderStore: (state, action: PayloadAction<Partial<BuilderStoreReducer>>) => {
      return { ...state, ...action.payload };
    },
    updateApplicationSettings: (state, action: PayloadAction<ApplicationSettings>) => {
      return { ...state, applicationSettings: action.payload };
    },
  },
});

export const { updateBuilderStore, updateApplicationSettings } = builderStoreSlice.actions;

export default builderStoreSlice.reducer;
